import React from 'react';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import {
  useDetalleTablaStyles,
  CLASE_TABLA_DETALLE,
  CLASE_PAPER_DETALLE,
} from '../general/Detalle';

export default function PersonaDetalle({ persona }) {
  const classes = useDetalleTablaStyles();
  let { usuario, login_directorio, identificacion, tipo_identificacion, primer_nombre, segundo_nombre, primer_apellido, segundo_apellido, correo, correo_personal, telefono, indicativo_celular, celular, tipo } = persona;

  return (
    <Paper square elevation={0} className={`${classes.paper} ${CLASE_PAPER_DETALLE}`}>
      <Table className={`${classes.table} ${CLASE_TABLA_DETALLE}`} aria-label="Detalle de persona">
        <TableBody>
          <TableRow key={1}>
            <TableCell component="th" scope="row" className={classes.cellLabel}>Tipo Persona</TableCell>
            <TableCell align="left" className={classes.cellValue}>{tipo == "1" ? 'PERSONA INTERNA' : 'PERSONA EXTERNA'}</TableCell>
          </TableRow>
          <TableRow key={2}>
            <TableCell component="th" scope="row" className={classes.cellLabel}>Nombre Completo</TableCell>
            <TableCell align="left" className={classes.cellValue}>{`${primer_nombre} ${segundo_nombre} ${primer_apellido} ${segundo_apellido}`}</TableCell>
          </TableRow>
          <TableRow key={3}>
            <TableCell component="th" scope="row" className={classes.cellLabel}>Correo</TableCell>
            <TableCell align="left" className={classes.cellValue}>{correo}</TableCell>
          </TableRow>
          <TableRow key={4}>
            <TableCell component="th" scope="row" className={classes.cellLabel}>Tipo Identificación</TableCell>
            <TableCell align="left" className={classes.cellValue}>{tipo_identificacion.nombre}</TableCell>
          </TableRow>
          <TableRow key={5}>
            <TableCell component="th" scope="row" className={classes.cellLabel}>Identificación</TableCell>
            <TableCell align="left" className={classes.cellValue}>{identificacion}</TableCell>
          </TableRow>
          <TableRow key={6}>
            <TableCell component="th" scope="row" className={classes.cellLabel}>Usuario</TableCell>
            <TableCell align="left" className={classes.cellValue}>{usuario}</TableCell>
          </TableRow>
          { celular === null ? null : /* only shows if celular is different from null */
          <TableRow key={7}>
            <TableCell component="th" scope="row" className={classes.cellLabel}>Celular</TableCell>
            { indicativo_celular === null ?
              <TableCell align="left" className={classes.cellValue}>{celular}</TableCell> :
              <TableCell align="left" className={classes.cellValue}>+{indicativo_celular} {celular}</TableCell>
            }
          </TableRow>
          }
          { telefono === null ? null : /* only shows if telefono is different from null */
          <TableRow key={8}>
            <TableCell component="th" scope="row" className={classes.cellLabel}>Telefono</TableCell>
            <TableCell align="left" className={classes.cellValue}>{telefono}</TableCell>
          </TableRow>
          }
          { correo_personal === null ? null : /* only shows if correo personal is different from null */
          <TableRow key={9}>
            <TableCell component="th" scope="row" className={classes.cellLabel}>Correo Personal</TableCell>
            <TableCell align="left" className={classes.cellValue}>{correo_personal}</TableCell>
          </TableRow>
          }
          <TableRow key={10}>
            <TableCell component="th" scope="row" className={classes.cellLabel}>Tipo Autenticación</TableCell>
            <TableCell align="left" className={classes.cellValue}>{login_directorio ? 'Directorio Activo' : 'Aplicación'}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Paper>
  );
}

PersonaDetalle.propTypes = {
  //variables
  persona: PropTypes.shape({
    id: PropTypes.number.isRequired,
    tipo_identificacion: PropTypes.object.isRequired,
    identificacion: PropTypes.number.isRequired,
    primer_nombre: PropTypes.string.isRequired,
    segundo_nombre: PropTypes.string,
    primer_apellido: PropTypes.string.isRequired,
    segundo_apellido: PropTypes.string,
    correo: PropTypes.string.isRequired,
    usuario: PropTypes.string.isRequired,
  }),
}
